import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import RefreshIcon from "@material-ui/icons/Refresh";
import { makeStyles } from "@material-ui/core/styles";
import Bugsnag from "@bugsnag/js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },

  errorMessage: {
    marginBottom: 40,
  },
}));

const ErrorPanel = ({ error }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    console.log("Sending BugSnag notification...");
    console.log(error);
    console.log(error.message);
    Bugsnag.notify(error);
  }, [error]);

  return (
    <div className={classes.root}>
      <h1>{t("error_panel_title")}</h1>
      <h2 className={classes.errorMessage}>{error.message}</h2>
      <Button
        startIcon={<RefreshIcon />}
        onClick={() => window.location.reload(true)}
        color="primary"
        variant="contained"
      >
        {t("error_panel_reload")}
      </Button>
    </div>
  );
};

export default ErrorPanel;
